import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

const _get = async (queryParamFilters, queryParam, setParams, setMetadata) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParamFilters || undefined,
  }

  setParams?.(params)

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/route-optimization',
    params: params,
  })

  setMetadata?.(response?.data.metadata)

  return {
    ...response?.data,
    data: {
      ...response?.data.data,
    },
  }
}

export const get = (queryParamFilters, setParams, setMetadata) => async (queryParam) =>
  await _get(queryParamFilters, queryParam, setParams, setMetadata)

export const store = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/route-optimization',
    data,
  })

  return response?.data
}

export const show = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/route-optimization/${id}/result`,
  })

  return response?.data
}

export const showSetting = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/route-optimization/${id}/setting`,
  })

  return response?.data
}

const _getSettingDelivery = async (id, queryParam) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam.filters || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/route-optimization/${id}/delivery-orders`,
    params: params,
  })

  return {
    ...response?.data,
  }
}

export const getSettingDelivery = (id) => async (queryParam) =>
  await _getSettingDelivery(id, queryParam)

const _getSettingVehicle = async (id, queryParam, routeOptimizationVehicleId) => {
  const params = {
    limit: queryParam.limit,
    page: queryParam.page,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    route_optimization_vehicle_id: routeOptimizationVehicleId || undefined,
  }

  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/route-optimization/${id}/vehicles`,
    params: params,
  })

  return {
    ...response?.data,
  }
}

export const getSettingVehicle = (id, routeOptimizationVehicleId) => async (queryParam) =>
  await _getSettingVehicle(id, queryParam, routeOptimizationVehicleId)

export const createFO = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/route-optimization/${id}/fleet-task`,
    data,
  })

  return response?.data
}

export const rerun = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PUT',
    url: `/route-optimization/${id}/rerun`,
  })

  return response?.data
}

export const cancel = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `/route-optimization/${id}/cancel`,
  })

  return response?.data
}

export const getRouteOptimizationUsage = async () => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `route-optimization/usage`,
  })

  return response?.data
}

export const reOptimize = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PUT',
    url: `/route-optimization/${id}/re-optimize`,
    data,
  })

  return response?.data
}

export const movement = async (id, rov_id, rop_id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/route-optimization/${id}/vehicle/${rov_id}/point/${rop_id}/movement`,
    data,
  })

  return response?.data
}

export const rollback = async (id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/route-optimization/${id}/rollback`,
  })

  return response?.data
}


export const getDetailVehicleDelivery = (id, rov_id) => async () => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/route-optimization/${id}/vehicle/${rov_id}/delivery-orders`,
  })

  const deliveryOrders = response?.data?.data?.delivery_orders || []
  
  return {
    ...response?.data,
    data: {
      ...response?.data?.data,
      paginated_result: deliveryOrders,
      ids: deliveryOrders.map(order => order.id),
    },
    metadata: {
      page: 1,
      total_count: deliveryOrders.length,
    },
  }
}


export const assignVehicle = async (id, rov_id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PUT',
    url: `/route-optimization/${id}/vehicle/${rov_id}/assignment`,
    data,
  })

  return response?.data
}

export const suggestionSequenceMovement = async (id, rov_id, do_id) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `/route-optimization/${id}/vehicle/${rov_id}/delivery-orders/${do_id}/suggestion`,
  })

  return response?.data
}

export const moveDeliveryToServedVehicle = async (id, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `/route-optimization/${id}/movement-order`,
    data,
  })

  return response?.data
}